import styled from "styled-components";
import {
	MapContainer as UnstyledMapContainer,
	Popup as UnstyledPopup,
} from "react-leaflet";

export const MapContainer = styled(UnstyledMapContainer)`
	height: 100%;
	width: 100%;
`;

export const Popup = styled(UnstyledPopup)`
	//width: 500px;
`;

export const Image = styled.img`
	max-width: 100%;
	height: auto;
	border-radius: 8px;
`;

export const PopupContentContainer = styled.div`
	max-width: 200px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
`;

export const PopupHeader = styled.div`
	font-size: 16px;
	font-weight: 700;
	margin-top: 10px;
`;

export const PopupText = styled.div`
	margin-top: 10px;
`;

export const PopupLink = styled.button`
	margin-top: 10px;
	margin-bottom: 10px;
	border: solid #333 1px;
	border-radius: 8px;
	padding: 8px;
	outline: none;
	background: none;
`;
